import 'leaflet'
import 'leaflet.markercluster'
import 'leaflet.featuregroup.subgroup'

import MarkerCreator from './MarkerCreator.js'
import PopupCreator from './PopupCreator.js'

import Layer from './layer/Layer.js'

class BaseLayerDrawer {

  vm = null
  _map = null
  _layers = null
  cachedIcons = {}

  constructor (map, opts = {vm: null}) {
    this.vm = opts.vm
    this._map = map

    this.popupCreator = new PopupCreator(this.vm)
    this.markerCreator = new MarkerCreator(this.vm)
  }

  removeLayers () {
    for (let key in this._layers) {
      this._layers[key].remove()
    }
  }

  setLayersConfigAndDraw (layerConfig) {
    let layers = {}
    for (let name in layerConfig) {
      let layer = layerConfig[name]
      let groups = {}
      if (layer.groups) {
        for (let groupName in layer.groups) {
          if (layer.groups[groupName]) {
            let restApiOrder = layer.groups[groupName].restApiOrder
            groups[restApiOrder] = {
              getMarkerIcon: (iconType, subIconType, model) => this.getMarkerIcon(iconType, subIconType, model),
              layerConfig: layer,
              subLayerConfig: layer.groups[groupName],
              checkbox: groupName
            }
          }
        }
      }

      layers[name] = this.createLayer(name, layer, groups)
    }

    this._layers = layers
    return this._layers
  }

  createLayer (checkbox, layer, groups) {
    return new Layer(this._map, {
      checkbox,
      divIcon: (cluster) => this.getClusterIcon(cluster, layer),
      groups
    }, {vm: this.vm, popupCreator: this.popupCreator})
  }

  /**
   * create or return from cache
   * @param iconType
   * @param subIconType
   * @param model
   * @returns {*}
   */
  getMarkerIcon (iconType, subIconType, model) {
    let cacheKey = `${iconType}_${subIconType}_${model.status_id || 0}`
    if (!this.cachedIcons[cacheKey]) {
      this.cachedIcons[cacheKey] = this.markerCreator.createIconObject(
        iconType,
        subIconType,
        model
      )
    }
    return this.cachedIcons[cacheKey]
  }

  getClusterIcon (cluster, layer) {
    return L.divIcon({
      className: layer.className,
      html: cluster.getChildCount(),
      iconSize: [36, 36],
      iconAnchor: [18, 18]
    })
  }
}

export default BaseLayerDrawer
